import React, { useState, useRef } from "react";
import { QRCodeSVG, QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminQRCode() {
  const base = window.location.origin;
  const canvasRef = useRef(null);
  const [tamanho, setTamanho] = useState(280);

  const links = [
    { label: "QR Code do Cliente (genérico)", url: `${base}/qrcode`, desc: "Imprima e cole na embalagem. Cliente escaneia, digita CPF e o sistema localiza o pedido importado.", testid: "qr-cliente" },
    { label: "Link Cadastro Montador", url: `${base}/cadastro-montador`, desc: "Envie para técnicos novos. Eles se cadastram e o sistema cria o acesso ao painel automaticamente.", testid: "qr-montador" },
    { label: "Link Cadastro Montadora", url: `${base}/cadastro-montadora`, desc: "Envie para montadoras parceiras. Após cadastro, têm acesso imediato ao painel regional.", testid: "qr-montadora" },
  ];

  const baixarPNG = (label) => {
    const canvas = document.getElementById(`canvas-${label}`);
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = `pim-${label}.png`;
    link.click();
  };

  const copiar = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("Link copiado");
  };

  return (
    <div className="p-8">
      <div className="mb-8">
        <div className="label-cap">SaaS</div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">QR Codes & Links públicos</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">
          Use estes QR Codes e links para escalar a operação: distribuir para clientes,
          recrutar montadores e parceiros automaticamente. Tudo monitorado neste painel.
        </p>
      </div>

      <div className="flex items-center gap-3 mb-6">
        <Label className="label-cap">Tamanho (px)</Label>
        <Input type="number" value={tamanho} onChange={(e) => setTamanho(Number(e.target.value))}
          className="w-24" min={120} max={600} data-testid="qr-tamanho" />
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {links.map((l) => (
          <div key={l.label} className="border border-border bg-white p-6" data-testid={l.testid}>
            <div className="label-cap mb-2">{l.label}</div>
            <div className="bg-white border border-border p-4 flex items-center justify-center mt-3" style={{ minHeight: tamanho + 32 }}>
              <QRCodeCanvas id={`canvas-${l.label}`} value={l.url} size={tamanho}
                fgColor="#142766" bgColor="#FFFFFF" level="M" includeMargin={false} />
            </div>
            <div className="mt-3 break-all text-xs font-mono text-muted-foreground bg-[#F4F4F5] p-2 border border-border">
              {l.url}
            </div>
            <p className="mt-3 text-xs text-muted-foreground">{l.desc}</p>
            <div className="mt-4 flex gap-2">
              <Button variant="outline" className="btn-sharp flex-1" onClick={() => copiar(l.url)}
                data-testid={`copy-${l.testid}`}>Copiar link</Button>
              <Button className="btn-sharp brand-bg text-white flex-1" onClick={() => baixarPNG(l.label)}
                data-testid={`download-${l.testid}`}>Baixar PNG</Button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 border border-border bg-[#F4F4F5] p-6 text-sm">
        <div className="label-cap mb-2">Como funciona</div>
        <ol className="space-y-2 text-sm list-decimal list-inside">
          <li>Importe a planilha de clientes em <strong>Importar Planilha</strong>.</li>
          <li>Imprima o <strong>QR Code do Cliente</strong> e cole na embalagem do produto.</li>
          <li>Cliente escaneia, digita CPF, confirma dados → sistema distribui automaticamente para montadores.</li>
          <li>Montador aceita, propõe 3 datas, cliente confirma → fluxo operacional completo.</li>
          <li>Tudo registrado em auditoria imutável neste painel.</li>
        </ol>
      </div>
    </div>
  );
}
